export function compare(a: string | number, b: string | number) {
  if (typeof a === 'string' && typeof b === 'string') {
    return a.toLowerCase().localeCompare(b.toLowerCase());
  }

  return a > b ? 1 : a < b ? -1 : 0;
}
